import React from 'react';
import { Mail, CheckCircle } from 'lucide-react';

const ListingRemovalPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="listing-removal-page">
      <div className="container mx-auto px-4 sm:px-6 md:px-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8 font-heading text-center">
          Request Listing Removal
        </h1>
        
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10">
          <div className="prose prose-slate max-w-none text-center">
            <p className="text-slate-600 leading-relaxed mb-6">
              If you are an auction house, property owner, or authorized representative and would like a listing removed or updated, please contact us.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">How to Request Removal</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Send an email to:
            </p>
            <div className="flex items-center justify-center gap-2 text-[#F5A623] font-medium mb-6 text-lg">
              <Mail className="h-5 w-5" />
              <a href="mailto:Support@AuctionGuru.co.uk" className="hover:underline">
                Support@AuctionGuru.co.uk
              </a>
            </div>

            <p className="text-slate-600 leading-relaxed mb-4">
              Include the following:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-8 space-y-2 text-left max-w-md mx-auto">
              <li>Your name and organization</li>
              <li>The listing URL on AuctionGuru</li>
              <li>The original source URL (if available)</li>
              <li>Reason for removal or correction</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mb-4">Our Commitment</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We respect the rights of content owners and will:
            </p>
            <div className="space-y-3 mb-8 max-w-md mx-auto">
              <div className="flex items-center justify-center gap-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-slate-600">Review all requests promptly</span>
              </div>
              <div className="flex items-center justify-center gap-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-slate-600">Remove or update listings where appropriate</span>
              </div>
              <div className="flex items-center justify-center gap-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-slate-600">Respond within 48 hours</span>
              </div>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
              <p className="text-slate-600 leading-relaxed">
                AuctionGuru aims to work collaboratively with auction houses and data providers to ensure accurate and respectful use of publicly available information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingRemovalPage;
